export enum AuthenticationType {
  AD = 'AD',
  ClientCertificate = 'CLIENT_CERTIFICATE',
  // when fallback is enabled, users can authenticate with username/password
  ClientCertificateWithFallback = 'CLIENT_CERTIFICATE_WITH_FALLBACK',
  Kerberos = 'KERBEROS',
  Local = 'LOCAL',
  OpenId = 'OPENID',
  Saml = 'SAML',
  Sspi = 'SSPI',
  External = 'EXTERNAL'
}

export interface IAuthenticationType {
  type: AuthenticationType;
}

export interface IServerCustomization {
  customHeaderLogo?: ICustomLogo;
  customSignInLogo?: ICustomLogo;
  customCompactLogo?: ICustomLogo;
  serverName?: string;
}

export interface ICustomLogo {
  path: string;
  link: string;
  width: number;
  height: number;
}

export let DomainFamily = {
  ActiveDirectory: 'activedirectory', // the server works with AD
  Local: 'local', // local authentication
  External: 'external' // used by Tableau Online
};

export interface IPreloginCustomization {
  preloginNotificationImgUrl?: string;
  preloginNotificationImgLink?: string;
  resetPasswordUrl?: string;
}

export interface IServerSettingsUnauthenticated {
  authenticationType?: IAuthenticationType;
  customization?: IServerCustomization;
  defaultLanguage?: string;
  defaultLocale?: string;
  guestEnabled?: boolean;
  wgEnabled?: boolean;
  domainFamily: string;
  licenseExpirationDate: string; // datetime(ISO 8601 UTC): YYYY-MM-DDThh:mm:ssZ
  preloginCustomization: IPreloginCustomization;
  siteSamlEnabled: boolean;
  hideAdminVizStatsForLoadTimes: boolean;
  hideAdminVizPerformanceOfViews: boolean;
  tableauIdSupported: boolean;
  connectedClientsVisible: boolean;
  embeddedVizForSiteSamlSupported: boolean;
  samlServiceEntityId: string;
  dsdPhoneSize?: number;
  dsdTabletSize?: number;
  passwordResetEnabled: boolean;
  desktopSamlDisabled: boolean;
  bridgeEnabled?: boolean;
  signInNoteText?: string;
  signInNoteUrl?: string;
  signInNoteEnabled: boolean;
  enableDeepLinking: boolean;
  // Note: The server currently returns 'product'.
  // This is not desirable.  The client should not use this property.
}
